import React, { useEffect, useState, ElementRef, useContext } from 'react';

import { ServiceRegistry } from '../../models/service-registry';
import { EventService } from '../../models/event-service';
import { FilterStorage } from '../../models/filterstorage';
import Select from 'react-select';
import moment from "moment-timezone";
import { LOCALEMAP, REGIONS } from '../../constants';
import { DateRangePicker } from "react-date-range";
import { removeDuplicate } from '../../utils';
import { ConfigContext } from "../../App";
import { DropDownProp } from '../../proptype';
import OMEGA from '../../omega';
import { BsoMapping } from '../../models/mapping-service';
const currentLocale: any = LOCALEMAP[window.locale];
moment.locale(currentLocale);

const rdrLocales = require('react-date-range/dist/locale');

export default function Filter(props: any) {
    const eventDefaultValue = {
        element: "Search dropdown",
        action: "change",
        type: "List items",
        widget: {
            name: "filter",
            type: "component"
        },
        feature: props.cloudName + "-" + props.type + " page" + " filters"
    }

    function omega_capture(element: any, widget_name: any, widget_type: any) {
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            element: element,
            widget: {
                name: widget_name,
                type: widget_type
            },
        }]);
    }
    const [state, setState] = useState([{
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection'
    }]);
    const [dateRange, setDateRange] = useState([moment(new Date()).format('DD/MM/YYYY'), moment(new Date()).format('DD/MM/YYYY')]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentDateRange, setCurrentDateRange] = useState('today');
    const [services, setServices] = useState<DropDownProp[]>([]);
    const [environments, setEnvironments] = useState<DropDownProp[]>([]);
    const [eventIds, setEventIds] = useState<DropDownProp[]>([]);
    const [regions, setRegions] = useState(REGIONS.map((region: any) => {
            return {
                value: region.id, label: region.name
            };
        }));
    const [mounted, setMounted] = useState(true);
    const [serviceAndEnvironements, setServiceAndEnvironements] = useState<any>({});
    const [prevCloud, setPrevCloud] = useState(props.cloud);
    const locales = useContext(ConfigContext).appConfig.languageData;

    const serviceRegistry: ServiceRegistry = ServiceRegistry.init();
    const eventService: EventService = EventService.init();
    eventService.setLocales(locales);
    const filterInstance = FilterStorage.init(props.cloud);
    const [bsomapping, setBsoMapping] = useState<any>({});
    

    const [isDatePickOpen, setIsDatePickOpen] = useState(false)
    
    // Add useEffect to patch calendar DOM for table semantics
    useEffect(() => {
        if (!isDatePickOpen) return;
        
        const patchCalendarDOM = () => {
            const monthContainer = document.querySelector('.rdrMonth');
            if (!monthContainer) return;
            
            // Patch header row
            const weekDaysContainer = monthContainer.querySelector('.rdrWeekDays');
            if (weekDaysContainer && !weekDaysContainer.getAttribute('role')) {
                weekDaysContainer.setAttribute('role', 'row');
                const weekDays = weekDaysContainer.querySelectorAll('.rdrWeekDay');
                weekDays.forEach((day) => {
                    if (!day.getAttribute('role')) {
                        day.setAttribute('role', 'columnheader');
                    }
                });
            }
            
            // Patch day grid
            const daysContainer = monthContainer.querySelector('.rdrDays');
            if (daysContainer && !daysContainer.getAttribute('role')) {
                daysContainer.setAttribute('role', 'grid');
                
                const dayButtons = Array.from(daysContainer.querySelectorAll('.rdrDay'));
                
                // Group days into weeks (7 days each)
                for (let weekIndex = 0; weekIndex < Math.ceil(dayButtons.length / 7); weekIndex++) {
                    const weekStart = weekIndex * 7;
                    const weekEnd = Math.min(weekStart + 7, dayButtons.length);
                    const weekDays = dayButtons.slice(weekStart, weekEnd);
                    
                    // Create row marker for this week
                    const rowMarkerId = `calendar-week-${weekIndex}`;
                    let rowMarker = daysContainer.querySelector(`#${rowMarkerId}`) as HTMLElement | null;
                    
                    if (!rowMarker) {
                        rowMarker = document.createElement('div');
                        rowMarker.id = rowMarkerId;
                        rowMarker.setAttribute('role', 'row');
                        rowMarker.style.position = 'absolute';
                        rowMarker.style.width = '0';
                        rowMarker.style.height = '0';
                        rowMarker.style.overflow = 'hidden';
                        daysContainer.appendChild(rowMarker);
                    }
                    
                    // Set up aria-owns relationship and gridcell roles
                    const dayIds: string[] = [];
                    weekDays.forEach((day, colIndex) => {
                        const dayId = `calendar-day-${weekIndex}-${colIndex}`;
                        if (!day.id) {
                            day.id = dayId;
                        }
                        if (!day.getAttribute('role')) {
                            day.setAttribute('role', 'gridcell');
                            day.setAttribute('aria-rowindex', String(weekIndex + 2)); // +2 because header is row 1
                            day.setAttribute('aria-colindex', String(colIndex + 1));
                        }
                        dayIds.push(day.id);
                    });
                    
                    if (!rowMarker.getAttribute('aria-owns')) {
                        rowMarker.setAttribute('aria-owns', dayIds.join(' '));
                    }
                }
            }
        };
        
        // Initial patch after a brief delay to ensure DOM is ready
        const timeoutId = setTimeout(patchCalendarDOM, 100);
        
        // Set up MutationObserver for month navigation
        const monthContainer = document.querySelector('.rdrMonth');
        let observer: MutationObserver | null = null;
        
        if (monthContainer) {
            observer = new MutationObserver(() => {
                patchCalendarDOM();
            });
            observer.observe(monthContainer, { childList: true, subtree: true });
        }
        
        return () => {
            clearTimeout(timeoutId);
            if (observer) {
                observer.disconnect();
            }
        };
    }, [isDatePickOpen]);
    const today = new Date();
    const minDate = new Date((new Date()).setDate(today.getDate() - 39));
    const controlRefs: any = {
        productRef: null,
        regionRef: null,
        serviceRef: null,
        environmentRef: null,
        eventIdRef: null
    };
    const dateFilters = [{
        key: 'today',
        value: locales.current
    }, {
        key: '7_days',
        value: locales.last_7_days
    }, {
        key: '40_days',
        value: locales.last_40_days
    }, {
        key: 'custom',
        value: locales.custom
    }];
    const bsoMapping: BsoMapping = BsoMapping.init();

    // Add useEffect to detect cloud changes and reset filters
    useEffect(() => {
        if (mounted && prevCloud !== props.cloud) {
            setPrevCloud(props.cloud);
            filterInstance.setContext({
                type: props.type,
                cloud: props.cloud,
            });
            
            // Ensure event ID dropdown is cleared
            if (controlRefs.eventIdRef) {
                controlRefs.eventIdRef.setState({
                    inputValue: "",
                    menuIsOpen: false,
                    value: []
                });
            }
            
            // Clear all filters including event IDs
            clearAll();
            
            // Reset event IDs in filter storage
            filterInstance.setValue('eventIds', []);
        }
    }, [props.cloud]);

    useEffect(() => {
        if (mounted && props.clearAll) {
            filterInstance.setContext({
                type: props.type,
                cloud: props.cloud,
            });
            clearAll();
        }
    }, [props.clearAll]);



    useEffect(() => {

        
        if (mounted) {
            if (controlRefs?.serviceRef && props?.defaultOffering) {
                controlRefs.serviceRef.setState({
                    inputValue: "",
                    menuIsOpen: false,
                    value: [{
                        value: props.defaultOffering.id,
                        label: props.defaultOffering.name
                    }]
                });
                filterInstance.setValue('offerings', [props.defaultOffering.id]);
                props.onFilter();
            }

            if (props.updateDate) {
             
                let filter = filterInstance.getValue();
                if (filter?.date?.length) {
                    let startDate = new Date(filter.date[0]),
                        endDate = new Date(filter.date[1]),
                        _startDate = moment(startDate).format('YYYY-MM-DD'),
                        _endDate = moment(endDate).format('YYYY-MM-DD');
                    setCurrentDateRange('custom');
                    setDateRange([_startDate, _endDate]);
                    setState([{
                        startDate: startDate,
                        endDate: endDate,
                        key: 'selection'
                    }]);
                }
            }
        }
       

    }, [props.defaultOffering, props.updateDate]);

    

    useEffect(() => {
        if (mounted) {
        
            if(props.customDate &&  props.customDate!==""){
                setCustomDate();
            }  //changed on product page
            if(props.customRegions && props.customRegions.length){
                if (filterInstance?.getValue()?.regions?.length && controlRefs?.regionRef) {
                    const regionValues = (filterInstance?.getValue()?.regions as unknown as string[])?.map((regionId: string) => {
                        const region = REGIONS.find((r: any) => r.id === regionId);
                        return {
                            value: regionId, 
                            label: region ? region.name : regionId
                        };
                    });
                    
                    controlRefs.regionRef.setState({
                    inputValue: "",
                    menuIsOpen: false,
                    value: regionValues
                    });
                }
            }
            if(props.customEventIds && props.customEventIds.length){
                if (filterInstance?.getValue()?.eventIds?.length && controlRefs?.eventIdRef) {
                    let eventIdValues = props.customEventIds.map((eventId:any)=>{return {value: eventId, label: eventId}})
                    controlRefs.eventIdRef.setState({
                        inputValue: "",
                        menuIsOpen: false,
                        value: eventIdValues
                    });
                }
            }
        }
    },[props.customDate, props.customRegions, props.customEventIds]);

    useEffect(() => {
        
        if (mounted) {
       
            if(props.events && props.events.length){
                // Only call updateServicesAndEnvs if bsomapping is loaded
                    updateServicesAndEnvs(filterInstance.getValue());
                updateEventIds();

            }

        }
    },[props.events]);

    useEffect(() => {
        if (mounted && Array.isArray(bsomapping) && bsomapping.length > 0 && props.events && props.events.length) {
            updateServicesAndEnvs(filterInstance.getValue());
        }
    }, [mounted, bsomapping]);

    useEffect(() => {
        if (mounted) {
            if (props.clearAll) {
                clearAll();
            }
        }
    }, [props.cloud]);

    
    function updateEventIds() {
        if (props.events && props.events.length) {
            let allEventIds: any = [];
            
            try {
                // Handle different event formats
                if (props.type === 'cloud') {
                    // Handle both possible data structures for cloud page
                    
                    // Check if format is from getIncidentsByDate (has formatedDate and incidents)
                    if (props.events[0].formatedDate !== undefined && props.events[0].incidents !== undefined) {
                       
                        props.events.forEach((dayEvent: any) => {
                            if (dayEvent.incidents && dayEvent.incidents.length) {
                                dayEvent.incidents.forEach((incident: any) => {
                                    if (incident.incidentId && !allEventIds.some((eventId: any) => eventId.value === incident.incidentId)) {
                                        allEventIds.push({
                                            value: incident.incidentId,
                                            label: incident.incidentId,
                                            isDisabled: false
                                        });
                                    } else if (incident.id && !allEventIds.some((eventId: any) => eventId.value === incident.id)) {
                                        allEventIds.push({
                                            value: incident.id,
                                            label: incident.id,
                                            isDisabled: false
                                        });
                                    }
                                });
                            }
                        });
                    } 
                    // Check if format is from getOnGoingEventsByType (has type and list)
                    else if (props.events[0].type !== undefined && props.events[0].list !== undefined) {
                        props.events.forEach((eventGroup: any) => {
                            if (eventGroup && eventGroup.list && eventGroup.list.length) {
                                eventGroup.list.forEach((incident: any) => {
                                    if (incident.incidentId && !allEventIds.some((eventId: any) => eventId.value === incident.incidentId)) {
                                        allEventIds.push({
                                            value: incident.incidentId,
                                            label: incident.incidentId,
                                            isDisabled: false
                                        });
                                    } else if (incident.id && !allEventIds.some((eventId: any) => eventId.value === incident.id)) {
                                        allEventIds.push({
                                            value: incident.id,
                                            label: incident.id,
                                            isDisabled: false
                                        });
                                    }
                                });
                            }
                        });
                    } else {
                        console.error("Unknown data format for cloud page events:", props.events[0]);
                    }
                } else {
                    // Product page format (getIncidentsByDate)
                    // Each item has formatedDate and incidents array
                    props.events.forEach((dayEvent: any) => {
                        if (dayEvent.incidents && dayEvent.incidents.length) {
                            dayEvent.incidents.forEach((incident: any) => {
                                if (incident.incidentId && !allEventIds.some((eventId: any) => eventId.value === incident.incidentId)) {
                                    allEventIds.push({
                                        value: incident.incidentId,
                                        label: incident.incidentId,
                                        isDisabled: false
                                    });
                                } else if (incident.id && !allEventIds.some((eventId: any) => eventId.value === incident.id)) {
                                    allEventIds.push({
                                        value: incident.id,
                                        label: incident.id,
                                        isDisabled: false
                                    });
                                }
                            });
                        }
                    });
                }
                
                setEventIds(allEventIds);
            } catch (err: any) {
                console.error("Error extracting event IDs:", err);
                omega_capture(
                    `Error extracting event IDs: ${err.message || err.toString()}`,
                    "filter",
                    "error"
                );
            }
        }
    }

    function updateServicesAndEnvs(filter: any) {
        if (props.product && Array.isArray(bsomapping) && bsomapping.length > 0) {
            let serviceAndEnvironements: any = serviceRegistry.getProductServicesAndEnvironments(props.product);
            setServiceAndEnvironements(serviceAndEnvironements);
            if (serviceAndEnvironements.services.length) {
                setServices(serviceAndEnvironements.services.map((service: any) => { return { value: service.id, label: service.name } }));
            }
            if (serviceAndEnvironements.environments.length) {
                let environments: any = [];
                if (filter?.regions?.length) {
                    let regions = filter?.regions || [];
                    environments = serviceAndEnvironements
                        .environments.filter((environment: any) => environment.regionId && environment.regionId.some((region: any) => -1 !== regions.indexOf(region)));
                } else {
                    environments = serviceAndEnvironements.environments;
                }
                updateEnvironmentDropdown(environments);
            }
            updateRegionDropdown();
            updateEventIds();
        }
    }

    useEffect(() => {
        if (
            serviceAndEnvironements?.environments?.length &&
            Array.isArray(bsomapping) &&
            bsomapping.length > 0
        ) {
            updateEnvironmentDropdown(serviceAndEnvironements.environments);
        }
    }, [serviceAndEnvironements]);

    useEffect(() => {

        setLoading(true);
        const [servicePromise, bsoMappingPromise]: any = [serviceRegistry.fetchCached(), bsoMapping.fetch(true)];
        const filter = filterInstance.getValue();
        
        if (filter?.date?.length) {
            let newDateRange = {
                startDate: new Date(filter.date[0]),
                endDate: new Date(filter.date[1]),
                key: 'selection'
            };

            setState([newDateRange]);
            setDateRange([filter.date[0], filter.date[1]]);
        }
        setCustomDate(true); // redirected from cloud page
        document.addEventListener('click', closeDatePicker);
        Promise.all([servicePromise, bsoMappingPromise])
            .then((result: any) => {
                if (mounted) {
                    setBsoMapping(result[1].data); // Set BSO mapping data
                   updateServicesAndEnvs(filter);
                    if (filter?.products?.length && controlRefs?.productRef) {
                        controlRefs.productRef.setState({
                            inputValue: "",
                            menuIsOpen: false,
                            value: buildProducts(filter.products)
                        });
                    }
                     // Set event ID if already in filter
                    if (filter?.eventIds && filter.eventIds.length && controlRefs?.eventIdRef) {
                        const eventIdValues = Array.isArray(filter.eventIds) ? filter.eventIds : [filter.eventIds];
                        const selectedEventIds = eventIdValues.map((eventId: string) => ({ 
                            value: eventId, 
                            label: eventId 
                        }));
                        
                        controlRefs.eventIdRef.setState({
                            inputValue: "",
                            menuIsOpen: false,
                            value: selectedEventIds
                        });
                    }
                }
            })
            .catch((error: any) => {
                console.error('Error in filter service promises:', error);
                omega_capture(
                    `Error in filter service promises: ${error.message || error.toString()}`,
                    "filter",
                    "error"
                );
                setLoading(false);
                setError(true);
            });

        return () => {
            setMounted(false);
            document.removeEventListener('click', closeDatePicker)
        }
    }, []);

    function getAllEventEnvironmentsOrRegions(type: string){

        var allEventEnvsOrRegions:any = [];
  
            props.events.forEach((dayEvent: any, index: number) => {
                dayEvent.incidents.forEach((incident: any, hindex: number) => {
                    var incidentinfo = type==="environments" ? incident.environments : incident.regions;
                    if(incidentinfo){
                        Object.values(incidentinfo).forEach((value:any) => {
                            if(!allEventEnvsOrRegions.some((envorregvalue:any) => envorregvalue.id === value.id)){
                                allEventEnvsOrRegions.push(value);
                            }
                        })
                    }
                })
            })
        return allEventEnvsOrRegions;

    }
    function envToBsoMapping(productoroffering: any ) {
        let mappedEnv: any = [];
        productoroffering.forEach((environment: any) => {
            if (!environment.grpId) {
                if (Array.isArray(bsomapping)) {
                    const mapping = bsomapping.find((map: any) => map.bsoId === environment.id);
                    environment.grpId = mapping?.groupId || environment.id;
                } else {
                    environment.grpId = environment.id;
                }
            }
            mappedEnv.push(environment);
        });
        return mappedEnv.filter((map: any, index: any, self: any) =>
            index === self.findIndex((mapindex: any) => mapindex.grpId === map.grpId)
        );
    }

    function updateEnvironmentDropdown(updatedEnv: any){
        var eventEnvs = getAllEventEnvironmentsOrRegions("environments");
        if(updatedEnv && updatedEnv?.length){
            let filteredEnv = envToBsoMapping(updatedEnv);
            var newenvList = filteredEnv.map((environment: any) => { 
                let disabled:boolean = true;
                if(props.events && props.events.length){
                    var allEnvsWithSameGrpId = updatedEnv.filter((env: any) => {
                        let envGrpId = env.grpId;
                        if (!envGrpId && Array.isArray(bsomapping)) {
                            const mapping = bsomapping.find((map:any) => map.bsoId === env.id);
                            envGrpId = mapping?.groupId || env.id;
                        }
                        return envGrpId === environment.grpId;
                    });
                    
                    allEnvsWithSameGrpId.forEach((env: any) => {
                        eventEnvs.forEach((eventEnv: any) => {
                            if(eventEnv.id === env.id){
                                disabled = false;
                            }
                        });
                    });
                }
                return { 
                    value: environment.grpId, 
                    label: environment.name, 
                    disabled: disabled,
                    allIds: updatedEnv.filter((env: any) => {
                        let envGrpId = env.grpId;
                        if (!envGrpId && Array.isArray(bsomapping)) {
                            const mapping = bsomapping.find((map:any) => map.bsoId === env.id);
                            envGrpId = mapping?.groupId || env.id;
                        }
                        return envGrpId === environment.grpId;
                    }).map((env: any) => env.id)
                };
            });
            
            setEnvironments(newenvList);
        }
    }


    function updateRegionDropdown(){
        var eventRegions = getAllEventEnvironmentsOrRegions("regions");
         if(regions && regions?.length){
            var newregionList = regions.map((region: any) => { 
                let disabled:boolean = true;
                if(props.events && props.events.length){
                    
                    eventRegions.forEach((eventregion: any) => {
                        if(eventregion.id === region.label){
                            disabled = false;
                        }
                    }) 
                }
                return { value: region.label, label: region.value, isDisabled:disabled}
            })
            if(newregionList.length){
                setRegions(newregionList);
            }  
        }
    }

    function setCustomDate(clearEvents?:boolean){
        if(props.customDate && props.customDate!==""){
            setCurrentDateRange('custom');
            updateDate(props.customDate, props.customDate);  
            setState([{
                        startDate: new Date(props.customDate),
                        endDate: new Date(props.customDate),
                        key: 'selection'
                    }]);
            if(clearEvents){
                props.clearEventFilter("all");
            }
        }
    }

    function clearAll(ignoreEvent?: boolean) {

        if (ignoreEvent === false) {
            props.clearEventFilter("all");
        }
        let filter = filterInstance.getValue();

        let newDateRange = {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        };
        Object.values(controlRefs).forEach((controlRef: any) => {
            if (controlRef) {
                controlRef.setState({
                    inputValue: "",
                    menuIsOpen: false,
                    value: []
                });
            }
        });

        // Explicitly ensure event ID is cleared from filter storage
        filterInstance.setValue('eventIds', []);
        
        if ((filter?.regions?.length || filter?.offerings?.length) && serviceAndEnvironements?.environments) {
            updateEnvironmentDropdown(serviceAndEnvironements.environments);
        }
        if (props.clearOffering && typeof props.clearOffering === 'function') {
            props.clearOffering(null);
        }

        // Re-update event IDs when clearing all filters
        updateEventIds();

        setState([newDateRange]);
        let today = moment().format('YYYY-MM-DD');
        setDateRange([today, today]);
        filterInstance.resetAll(props.cloud);
        setCurrentDateRange('today');
        props.onFilter(ignoreEvent === false ? 'all' : "");
    }

    function closeDatePicker(e: Event) {
        let el: any = e.target;

        if (!el.closest('.date-range')) {
            setIsDatePickOpen(false);
        }
    }

    function getproductNames() {
        let productList = serviceRegistry.getProductList(props.cloud);
        if (productList && productList.length) {
            return productList.map((product: any) => {
                return ({
                    value: product.id, label: product.name
                });
            });
        }
        return [];
    }


    function buildProducts(products: string[]) {
        return serviceRegistry.getProductList(props.cloud).filter((product: any) => {
            return products.includes(product.id);
        }).map((product: any) => {
            return ({
                value: product.id, label: product.name
            });
        });
    }

    function onSelect(e: any, from: string) {
        let filter = filterInstance.getValue();

        if (e.length) {
            e.forEach((item: any) => {
                if (from === 'environments') {
                    if (item.allIds && item.allIds.length) {
                        item.allIds.forEach((envId: string) => {
                            filterInstance.add(from, envId);
                        });
                    } else {
                        filterInstance.add(from, item.value);
                    }
                } else {
                    filterInstance.add(from, item.value);
                }
                OMEGA.init().updateAndTrack("event", [{
                    ...eventDefaultValue,
                    attributes: {
                        item1: item.label
                    },
                    widget: {
                        name: (from === "products" || from === "offerings") ? from + " select" : props.type + " page" + " " + from + " select",
                        type: "form"
                    },
                    search: {
                        term: item.label
                    }
                }]);
            });
        }
        else {
            filterInstance.setValue(from, []);
        }

        if (from === 'offerings') {
            let services: any = e.map((item: any) => item.value);

            if (serviceAndEnvironements?.environments?.length) {
                if (e.length) {
                    let serviceList: any = [], environmentList: any = [];
                    serviceList = serviceAndEnvironements.services.filter((service: any) => -1 !== services.indexOf(service.id))
                    environmentList = serviceList.reduce((environments: any, service: any) => {
                        if (service?.serviceEnvironments?.length) {
                            Array.prototype.push.apply(environments, service.serviceEnvironments);
                        }
                        return environments;
                    }, []);

                    environmentList = removeDuplicate(environmentList, 'id');
                    let regions = filter?.regions;
                    if (regions?.length) {
                        environmentList = environmentList.filter((env: any) => env.regionId.some((region: any) => -1 !== regions?.indexOf(region)))
                    }
                    filterInstance.clear('environments');
                    if (controlRefs.environmentRef) {
                        controlRefs.environmentRef.setState({
                            inputValue: "",
                            menuIsOpen: false,
                            value: []
                        });
                    }
                    updateEnvironmentDropdown(environmentList);
                } else {
                    if (serviceAndEnvironements?.environments?.length && filter?.regions?.length) {
                        let environmentList = serviceAndEnvironements.environments.filter((env: any) => env.regionId.some((region: any) => -1 !== filter?.regions?.indexOf(region)))
                         updateEnvironmentDropdown(environmentList);
                    } else {
                        updateEnvironmentDropdown(serviceAndEnvironements.environments);
                    }
                }

                if (props.clearOffering && typeof props.clearOffering === 'function') {
                    props.clearOffering(null);
                }
            }
        }

        if (from === 'regions' && serviceAndEnvironements?.environments?.length) {
            if (e.length) {
                let regions: any = e.map((item: any) => item.value),
                    environments: any = [], environmentList: any = [];


                if (serviceAndEnvironements?.services?.length && filter?.offerings?.length) {
                    let serviceList = serviceAndEnvironements.services.filter((servcie: any) => -1 !== filter?.offerings?.indexOf(servcie.id));

                    environmentList = serviceList.reduce((environments: any, service: any) => {
                        if (service?.serviceEnvironments?.length) {
                            Array.prototype.push.apply(environments, service.serviceEnvironments);
                        }
                        return environments;
                    }, []);

                    environmentList = removeDuplicate(environmentList, 'id');
                } else {
                    environmentList = serviceAndEnvironements.environments;
                }

                environments = environmentList.filter((environment: any) => environment.regionId && environment.regionId.some((region: any) => -1 !== regions?.indexOf(region)));

                filterInstance.clear('environments');
                if (controlRefs.environmentRef) {
                    controlRefs.environmentRef.setState({
                        inputValue: "",
                        menuIsOpen: false,
                        value: []
                    });
                }
                updateEnvironmentDropdown(environments);
            } else {
                if (serviceAndEnvironements?.services?.length && filter?.offerings?.length) {
                    let serviceList = serviceAndEnvironements.services.filter((servcie: any) => -1 !== filter?.offerings?.indexOf(servcie.id));

                    let environmentList = serviceList.reduce((environments: any, service: any) => {
                        if (service?.serviceEnvironments?.length) {
                            Array.prototype.push.apply(environments, service.serviceEnvironments);
                        }
                        return environments;
                    }, []);

                    environmentList = removeDuplicate(environmentList, 'id');
                    updateEnvironmentDropdown(environmentList);

                } else {
                    updateEnvironmentDropdown(serviceAndEnvironements.environments);
                }
            }
        }
        props.onFilter();
  
    }
    function updateDate(startDate: Date, endDate: Date) {
        let _startDate = moment(startDate).format('YYYY-MM-DD'),
            _endDate = moment(endDate).format('YYYY-MM-DD');
            
        // Preserve event IDs filter before updating date
        const filter = filterInstance.getValue();
        const currentEventIds = filter?.eventIds;
        
        setDateRange([_startDate, _endDate]);
        filterInstance.clear('date');
        filterInstance.setValue('date', [_startDate, _endDate]);
        
        // Restore event IDs filter after updating date if it existed
        if (currentEventIds && currentEventIds.length) {
            filterInstance.setValue('eventIds', currentEventIds);
        }
        
        props.onFilter();
    }
    function selectedDates(e: any) {
        let startDate: Date = new Date(e.selection.startDate), endDate: Date = new Date(e.selection.endDate);
        setState([e.selection]);
        updateDate(startDate, endDate);
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            attributes: {
                start_Date: startDate,
                end_Date: endDate
            },
            widget: {
                name: props.type + " page" + " " + "custom select",
                type: "date picker"
            },
            search: {
                term: `startDate: ${startDate} - endDate: ${endDate}`
            }
        }]);
    }

    return (
        <div className="filter-panel">
            <span className="filter-title-panel">
                <div className="clearfix">
                    <span className="filter-title">{locales.filter_by}</span>
                    <a href="#/" onClick={() => { clearAll() }} className="clear-all" tabIndex={0} onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            clearAll();
                        }
                    }}>{locales.clear_all}</a>
                    <a href="#/" onClick={() => { clearAll(false) }} className="clear-all-mobile" tabIndex={0} onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            clearAll(false);
                        }
                    }}>{locales.clear_all}</a>
                </div>
            </span>

             {/* Event ID Dropdown */}
            <div data-testid="event-id-filter" className="control-styles event-id">
                <Select
                    ref={(ref: ElementRef<any>) => {
                        if (ref) {
                            controlRefs.eventIdRef = ref;
                        }
                    }}
                    isMulti
                    placeholder={locales.event_id}
                    options={eventIds}
                    aria-label={locales.event_id}
                    onChange={(e: any) => { 
                        if (e && e.length) {
                            // Handle multi-select event IDs
                            const eventIdValues = e.map((item: any) => item.value);
                           
                            filterInstance.setValue('eventIds', eventIdValues);
                            
                            // Track analytics for each selected event ID
                            e.forEach((item: any) => {
                                OMEGA.init().updateAndTrack("event", [{
                                    ...eventDefaultValue,
                                    attributes: {
                                        item1: item.label
                                    },
                                    widget: {
                                        name: props.type + " page event id select",
                                        type: "form"
                                    },
                                    search: {
                                        term: item.label
                                    }
                                }]);
                            });
                        } else {
                            filterInstance.setValue('eventIds', []);
                            
                            // Make sure to update eventIds options again when selection is cleared
                            updateEventIds();
                        }
                        props.onFilter();
                    }}
                    isClearable={true}
                    noOptionsMessage={() => "No event IDs found"}
                    onKeyDown={e => {
                        if ((e.key === 'Enter' || e.key === ' ') && controlRefs.eventIdRef && !controlRefs.eventIdRef.state.menuIsOpen) {
                            e.preventDefault();
                            controlRefs.eventIdRef.setState({ menuIsOpen: true });
                        }
                    }}
                    components={{
                        ClearIndicator: (props: any) => {
                            const { components } = require('react-select');
                            const Clear = components.ClearIndicator as React.ComponentType<any>;
                            return (
                                <Clear
                                    {...props}
                                    innerProps={{
                                        ...props.innerProps,
                                        "aria-hidden": false,
                                        role: "button",
                                        tabIndex: 0,
                                        "aria-label": "Clear all selected options",
                                        onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                props.innerProps.onMouseDown?.(e as any);
                                            }
                                        },
                                    }}
                                />
                            );
                        }
                    }}
                />
            </div>
            {
                !props.product ?
                    <div data-testid="product-filter"className="control-styles products">
                        <Select
                            ref={(ref: ElementRef<any>) => {
                                if (ref) {
                                    controlRefs.productRef = ref;
                                }
                            }}
                            isMulti
                            placeholder={locales.product_placeholder}
                            options={getproductNames()}
                            aria-label={locales.product_placeholder}
                            onChange={(e: any) => { onSelect(e, 'products') }}
                            noOptionsMessage={() => locales.product_no_item}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && controlRefs.productRef && !controlRefs.productRef.state.menuIsOpen) {
                                    e.preventDefault();
                                    controlRefs.productRef.setState({ menuIsOpen: true });
                                }
                            }}
                            components={{
                                ClearIndicator: (props: any) => {
                                    const { components } = require('react-select');
                                    const Clear = components.ClearIndicator as React.ComponentType<any>;
                                    return (
                                        <Clear
                                            {...props}
                                            innerProps={{
                                                ...props.innerProps,
                                                "aria-hidden": false,
                                                role: "button",
                                                tabIndex: 0,
                                                "aria-label": "Clear all selected options",
                                                onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        props.innerProps.onMouseDown?.(e as any);
                                                    }
                                                },
                                            }}
                                        />
                                    );
                                }
                            }}
                        />
                    </div>
                    : <></>
            }


            {
                services.length ?
                    <div className="control-styles">
                        <Select
                            ref={(ref: ElementRef<any>) => {
                                if (ref) {
                                    controlRefs.serviceRef = ref;
                                }
                            }}
                            isMulti
                            placeholder={locales.offerings_placeholder}
                            options={services}
                            aria-label={locales.offerings_placeholder}
                            onChange={(e: any) => { onSelect(e, 'offerings') }}
                            noOptionsMessage={() => locales.offerings_no_item}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && controlRefs.serviceRef && !controlRefs.serviceRef.state.menuIsOpen) {
                                    e.preventDefault();
                                    controlRefs.serviceRef.setState({ menuIsOpen: true });
                                }
                            }}
                            components={{
                                ClearIndicator: (props: any) => {
                                    const { components } = require('react-select');
                                    const Clear = components.ClearIndicator as React.ComponentType<any>;
                                    return (
                                        <Clear
                                            {...props}
                                            innerProps={{
                                                ...props.innerProps,
                                                "aria-hidden": false,
                                                role: "button",
                                                tabIndex: 0,
                                                "aria-label": "Clear all selected options",
                                                onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        props.innerProps.onMouseDown?.(e as any);
                                                    }
                                                },
                                            }}
                                        />
                                    );
                                }
                            }}
                        />
                    </div> : <></>
            }

            <div data-testid="region-filter" className="control-styles">
                <Select
                    ref={(ref: ElementRef<any>) => {
                        if (ref) {
                            controlRefs.regionRef = ref;
                        }
                    }}
                    isMulti
                    placeholder={locales.region_placeholder}
                    options={regions}
                    aria-label={locales.region_placeholder}
                    onChange={(e: any) => { onSelect(e, 'regions') }}
                    noOptionsMessage={() => locales.region_no_item}
                    onKeyDown={e => {
                        if ((e.key === 'Enter' || e.key === ' ') && controlRefs.regionRef && !controlRefs.regionRef.state.menuIsOpen) {
                            e.preventDefault();
                            controlRefs.regionRef.setState({ menuIsOpen: true });
                        }
                    }}
                    components={{
                        ClearIndicator: (props: any) => {
                            const { components } = require('react-select');
                            const Clear = components.ClearIndicator as React.ComponentType<any>;
                            return (
                                <Clear
                                    {...props}
                                    innerProps={{
                                        ...props.innerProps,
                                        "aria-hidden": false,
                                        role: "button",
                                        tabIndex: 0,
                                        "aria-label": "Clear all selected options",
                                        onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                props.innerProps.onMouseDown?.(e as any);
                                            }
                                        },
                                    }}
                                />
                            );
                        }
                    }}
                />
            </div>

            {
                environments.length ?
                    <div className="control-styles">
                        <Select
                            ref={(ref: ElementRef<any>) => {
                                if (ref) {
                                    controlRefs.environmentRef = ref;
                                }
                            }}
                            isMulti
                            placeholder={locales.environments_placeholder}
                            options={environments}
                            aria-label={locales.environments_placeholder}
                            onChange={(e: any) => { onSelect(e, 'environments') }}
                            noOptionsMessage={() => locales.environments_no_item}
                            isOptionDisabled={(option: any) => option.disabled}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && controlRefs.environmentRef && !controlRefs.environmentRef.state.menuIsOpen) {
                                    e.preventDefault();
                                    controlRefs.environmentRef.setState({ menuIsOpen: true });
                                }
                            }}
                            styles={{
                                option: (provided: any, state: any) => ({
                                    ...provided,
                                    color: state.isFocused || state.isSelected ? '#595959' : provided.color,
                                }),
                                multiValueRemove: (provided: any, state: any) => ({
                                    ...provided,
                                    ':focus': {
                                        backgroundColor: '#D0342C',
                                        color: '#FFFFFF',
                                    }
                                }),
                                clearIndicator: (provided: any, state: any) => ({
                                    ...provided,
                                    svg: {
                                        fill: '#595959',
                                    }
                                }),
                                dropdownIndicator: (provided: any, state: any) => ({
                                    ...provided,
                                    svg: {
                                        fill: '#595959',
                                    }
                                })
                            }}
                            components={{
                                ClearIndicator: (props: any) => {
                                    const { components } = require('react-select');
                                    const Clear = components.ClearIndicator as React.ComponentType<any>;
                                    return (
                                        <Clear
                                            {...props}
                                            innerProps={{
                                                ...props.innerProps,
                                                "aria-hidden": false,
                                                role: "button",
                                                tabIndex: 0,
                                                "aria-label": "Clear all selected options",
                                                onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        props.innerProps.onMouseDown?.(e as any);
                                                    }
                                                },
                                            }}
                                        />
                                    );
                                }
                            }}
                        />
                    </div> : <></>
            }

           


            <div className="control-styles">
                <div className="date-range">

                <input readOnly type="text" placeholder="Select Date" value={`${moment(dateRange[0], "YYYY-MM-DD").format('L')} - ${moment(dateRange[1], "YYYY-MM-DD").format('L')}`} onClick={() => {
                            setIsDatePickOpen(!isDatePickOpen);
                        }}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setIsDatePickOpen(!isDatePickOpen);
                            }
                        }}
                    />
                    <div className={`picker ${currentDateRange} ${isDatePickOpen ? 'show' : ''}`} >
                        <ul className="date-custom-list" role="listbox">
                            {dateFilters.map((dateFilter: any, index: number) => (
                                <li
                                    key={index}
                                    tabIndex={0}
                                    role="option"
                                    aria-selected={currentDateRange === dateFilter.key}
                                    className={currentDateRange === dateFilter.key ? 'selected' : ''}
                                    onClick={() => {
                                        let startDate: Date, endDate: Date = new Date();
                                        if (dateFilter.key === '7_days') {
                                            startDate = new Date(new Date().setDate(today.getDate() - 6));
                                        } else if (dateFilter.key === '40_days') {
                                            startDate = new Date(new Date().setDate(today.getDate() - 39));
                                        } else {
                                            startDate = new Date();
                                            endDate = startDate;
                                        }
                                        setCurrentDateRange(dateFilter.key);
                                        if (dateFilter.key !== 'custom') {
                                            setIsDatePickOpen(false);
                                            updateDate(startDate, endDate);
                                            setState([{ startDate, endDate, key: 'selection' }]);
                                            OMEGA.init().updateAndTrack("event", [{
                                                ...eventDefaultValue,
                                                attributes: { start_Date: startDate, end_Date: endDate },
                                                widget: { name: props.type + " page" + " " + dateFilter.key + " select", type: "date picker" },
                                                search: { term: `startDate: ${startDate} - endDate: ${endDate}` }
                                            }]);
                                        }
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            let startDate: Date, endDate: Date = new Date();
                                            if (dateFilter.key === '7_days') {
                                                startDate = new Date(new Date().setDate(today.getDate() - 6));
                                            } else if (dateFilter.key === '40_days') {
                                                startDate = new Date(new Date().setDate(today.getDate() - 39));
                                            } else {
                                                startDate = new Date();
                                                endDate = startDate;
                                            }
                                            setCurrentDateRange(dateFilter.key);
                                            if (dateFilter.key !== 'custom') {
                                                setIsDatePickOpen(false);
                                                updateDate(startDate, endDate);
                                                setState([{ startDate, endDate, key: 'selection' }]);
                                                OMEGA.init().updateAndTrack("event", [{
                                                    ...eventDefaultValue,
                                                    attributes: { start_Date: startDate, end_Date: endDate },
                                                    widget: { name: props.type + " page" + " " + dateFilter.key + " select", type: "date picker" },
                                                    search: { term: `startDate: ${startDate} - endDate: ${endDate}` }
                                                }]);
                                            }
                                        }
                                    }}
                                >
                                    {dateFilter.value}
                                </li>
                            ))}
                        </ul>
                        <div className={currentDateRange === 'custom' ? "date-range clearfix active" : "date-range clearfix"}>
                            <DateRangePicker
                                onChange={selectedDates}
                                minDate={minDate}
                                maxDate={today}
                                inputRanges={[]}
                                moveRangeOnFirstSelection={false}
                                months={1}
                                dateDisplayFormat={currentLocale === "ja" ? "yoMMMdo" : "MMM d, yyyy"}
                                locale={rdrLocales[window.locale === "zh-tw" ? "zhTW" : window.locale === "zh-cn" ? "zhCN" : currentLocale || 'enUS']}
                                staticRanges={[]}
                                ranges={state}
                                ariaLabels={{
                                    monthPicker: 'Select month',
                                    yearPicker: 'Select year',
                                    prevButton: 'Previous month',
                                    nextButton: 'Next month'
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}